import React, {useState} from 'react'

const BarcodeUserSettingsContext = React.createContext({
  setUserSettings: () => {},
  userSettings: {},
})

function BarcodeUserSettingsContextProvider(props) {
  // [A]
  const [userSettings, setUserSettings] = useState({})

  const value = {
    setUserSettings,
    userSettings,
  }

  // [B]
  return (
    <BarcodeUserSettingsContext.Provider value={value}>
      {props.children}
    </BarcodeUserSettingsContext.Provider>
  )
}

const BarcodeUserSettingsContextConsumer = BarcodeUserSettingsContext.Consumer

export {
  BarcodeUserSettingsContext,
  BarcodeUserSettingsContextProvider,
  BarcodeUserSettingsContextConsumer,
}
